import { Endpoint } from "../config";

export type DashboardEndpointType =
  | "dashboard"
  | "analytics"
  | "reports"
  | "statistics"
  | "recentActivity";

export const dashboardEndpoints: Record<DashboardEndpointType, Endpoint> = {
  dashboard: {
    url: "dashboard/",
  },
  analytics: {
    url: "dashboard/analytics/",
  },
  reports: {
    url: "dashboard/reports/",
  },
  statistics: {
    url: "dashboard/statistics/",
  },
  recentActivity: {
    url: "dashboard/recent-activity/",
  },
};
